import { exportarCsv } from "@torre/costos";
import type { MonthSummary } from "@torre/expenses";
import { categoryIdList, categoryLabel } from "./format";

/** CSV del resumen mensual: una fila por mes, una columna por categoría. */
export function exportMonthRows(months: readonly MonthSummary[], language = "es"): string {
  return exportarCsv(months, [
    { key: "period", label: "Mes" },
    { key: "total", label: "Total MXN" },
    { key: "count", label: "Gastos" },
    { key: "withoutInvoice", label: "Sin factura" },
    ...categoryIdList().map((cat) => ({
      key: cat,
      label: categoryLabel(cat, language),
      value: (m: MonthSummary) => m.byCategory[cat] ?? 0,
    })),
  ]);
}
